module.exports = __webpack_public_path__ + "img/super-bundle-32.b159026.webp";